<template>
  <div class="flex align-center justify-center loader-wrapper oval">
    <div class="loader"></div>
  </div>
</template>

<script>
export default {
  name: "Loading"
}
</script>

<style scoped>
.loader-wrapper {
  position: absolute;
  z-index: 101;
  width: 100%;
  height: 100%;
  background-color: rgba(255, 255, 255, .8);
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
}
.loader {
  border: 4px solid #f3f3f3;
  border-radius: 50%;
  border-top: 4px solid #3498db;
  width: 40px;
  height: 40px;
  -webkit-animation: spin 1s linear infinite; /* Safari */
  animation: spin 1s linear infinite;
}

/* Safari */
@-webkit-keyframes spin {
  0% { -webkit-transform: rotate(0deg); }
  100% { -webkit-transform: rotate(360deg); }
}

@keyframes spin {
  0% { transform: rotate(0deg); }
  100% { transform: rotate(360deg); }
}
</style>
